import { request, success, failure, LOANS_REQUEST } from "./utilities";
import {
  getAllLoansOwnToMe,
  getAllLoansOwnToOthers,
  addNewLoan,
  deleteLoan,
} from "../api";
import { data, data_ } from "../../components/Loans/components/LoanData";

export function getLoansOwnToOthers() {
  return (dispatch) => {
    dispatch(success(LOANS_REQUEST.GET_LOANS_OWN_TO_OTHERS_SUCCESS, data));

    // dispatch(request(LOANS_REQUEST.GET_LOANS_OWN_TO_OTHERS_REQUEST));
    // getAllLoansOwnToOthers().then((res) => {
    //     if (res.data.status === 1) {
    //         dispatch(success(LOANS_REQUEST.GET_LOANS_OWN_TO_OTHERS_SUCCESS, res.data.data));
    //     }
    //     else {
    //         dispatch(failure(LOANS_REQUEST.GET_LOANS_OWN_TO_OTHERS_FAILURE, res.data.message));
    //     }
    // }, (error) => {
    //     dispatch(failure(LOANS_REQUEST.GET_LOANS_OWN_TO_OTHERS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
    // })
  };
}

export function getLoansOwnToMe() {
  return (dispatch) => {
    dispatch(success(LOANS_REQUEST.GET_LOANS_OWN_TO_ME_SUCCESS, data_));

    // dispatch(request(LOANS_REQUEST.GET_LOANS_OWN_TO_ME_REQUEST));
    // getAllLoansOwnToMe().then((res) => {
    //     if (res.data.status === 1) {
    //         dispatch(success(LOANS_REQUEST.GET_LOANS_OWN_TO_ME_SUCCESS, res.data.data));
    //     }
    //     else {
    //         dispatch(failure(LOANS_REQUEST.GET_LOANS_OWN_TO_ME_FAILURE, res.data.message));
    //     }
    // }, (error) => {
    //     dispatch(failure(LOANS_REQUEST.GET_LOANS_OWN_TO_ME_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
    // })
  };
}

export function addLoan(loanData, close) {
  return (dispatch) => {
    dispatch(request(LOANS_REQUEST.ADD_LOAN_REQUEST));
    var data = {
      name: loanData.loanName,
      phone: loanData.phoneNo,
      email: loanData.email,
      amount: loanData.amount,
      reason: loanData.reason,
      paidDate: "09/11/2020",
      dueDate: "09/11/2020",
      status: loanData.statusId,
      address: loanData.address,
      loanType: loanData.loanType,
    };
    dispatch(success(LOANS_REQUEST.ADD_LOAN_SUCCESS, data));
    if (close) {
      close();
    }
    // addNewLoan(loanData).then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(LOANS_REQUEST.ADD_LOAN_SUCCESS, response.data.data));
    //             if (close) {
    //                 close();
    //             }
    //         } else {
    //             dispatch(failure(LOANS_REQUEST.ADD_LOAN_FAILURE, response.data.message))
    //         }
    //     },
    //     error => {
    //         dispatch(failure(LOANS_REQUEST.ADD_LOAN_FAILURE), (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message));
    //     }
    // )
  };
}

export function removeLoan(loanId) {
  return (dispatch) => {
    dispatch(request(LOANS_REQUEST.DELETE_LOAN_REQUEST));
    var data = {
      loanId: loanId.id,
      loanType: loanId.type,
    };
    dispatch(success(LOANS_REQUEST.DELETE_LOAN_SUCCESS, data));
    // deleteLoan(loanId).then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(LOANS_REQUEST.DELETE_LOAN_SUCCESS, loanId ))
    //         } else {
    //             dispatch(failure(LOANS_REQUEST.DELETE_LOAN_FAILURE, response.data.message))
    //         }
    //     },
    //     error => {
    //         dispatch(failure(LOANS_REQUEST.DELETE_LOAN_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
    //     }
    // )
  };
}

export function editLoan(loanData, close) {
  return (dispatch) => {
    dispatch(request(LOANS_REQUEST.EDIT_LOAN_REQUEST));
    var data = {
      id: loanData.id,
      name: loanData.loanName,
      phone: loanData.phoneNo,
      email: loanData.email,
      amount: loanData.amount,
      reason: loanData.reason,
      paidDate: "09/11/2020",
      dueDate: "09/11/2020",
      status: loanData.statusId,
      address: loanData.address,
      loanType: loanData.loanType,
    };
    dispatch(success(LOANS_REQUEST.EDIT_LOAN_SUCCESS, data));
    if (close) {
      close();
    }
    // addNewLoan(loanData).then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(LOANS_REQUEST.EDIT_LOAN_SUCCESS, response.data.data));
    //             if (close) {
    //                 close();
    //             }
    //         } else {
    //             dispatch(failure(LOANS_REQUEST.EDIT_LOAN_FAILURE, response.data.message))
    //         }
    //     },
    //     error => {
    //         dispatch(failure(LOANS_REQUEST.EDIT_LOAN_FAILURE), (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message));
    //     }
    // )
  };
}
